import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';

import App from './app/reducer';
import Auth from './auth/reducer';
import User from './user/reducer';
import Location from './location/reducer';
import Access from './access/reducer';
import UserGroup from './usergroup/reducer';
import Log from './log/reducer';
import Dashboard from './dashboard/reducer';
//import { app } from 'firebase';
export default history =>
  combineReducers({
    router: connectRouter(history),
    App,
    Auth,
    User,
    Location,
    Access,
    UserGroup,
    Log,
    Dashboard,
  });
